import { useEffect, useReducer, useCallback, useState } from 'react';
import * as http from 'utils/http';
import config from 'config';
import copy from 'copy-to-clipboard';

const types = {
  FETCHING_DATA: 'FETCHING_DATA',
  FETCH_SUCCESSFUL: 'FETCH_SUCCESSFUL',
  FETCH_ERROR: 'FETCH_ERROR',
  TOGGLE_FILTER: 'TOGGLE_FILTER',
};

const JobsSummaryReducer = (state, { type, value }) => {
  switch (type) {
    case types.FETCHING_DATA:
      return {
        ...state,
        error: false,
        fetching: true,
      };
    case types.FETCH_SUCCESSFUL:
      return {
        ...state,
        fetching: false,
        rawData: value,
      };
    case types.FETCH_ERROR:
      return {
        ...state,
        error: true,
      };
    case types.TOGGLE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [value]: !state.filters[value],
        },
      };
    default: {
      console.error(`Unhandled action type: ${type}.`);
    }
  }
};

export const useFiltrableJobsInfoFromShipper = (shipperId, date) => {
  const [state, dispatch] = useReducer(JobsSummaryReducer, {
    fetching: false,
    filters: { NAME: true, PLATE: true, PHONE: true, PICKUP: true },
    rawData: [],
  });

  const { fetching, filters, rawData } = state;

  const getFilteredData = useCallback(() => {
    return (rawData || []).map((jobInfo) => {
      const {
        driver_name: driverName,
        driver_phone: driverPhone,
        pickups,
        plates,
        shipper_order_id: id,
      } = jobInfo;

      return {
        ...{ id },
        ...(driverName && filters['NAME'] && { driverName }),
        ...(plates && filters['PLATE'] && { plates }),
        ...(driverPhone && filters['PHONE'] && { driverPhone }),
        ...(pickups && filters['PICKUP'] && { pickups }),
      };
    });
  }, [rawData, filters]);

  const changeFilter = (filter) => {
    dispatch({ type: types.TOGGLE_FILTER, value: filter });
  };

  useEffect(() => {
    const fetchData = async (shipperId, date) => {
      try {
        dispatch({ type: types.FETCHING_DATA });
        const data = await http.get(
          `${config.API_URL}mercury/shippers/${shipperId}/export?date=${date}`
        );
        dispatch({ type: types.FETCH_SUCCESSFUL, value: data });
      } catch (e) {
        dispatch({ type: types.FETCH_ERROR });
      }
    };
    fetchData(shipperId, date);
  }, [shipperId, date]);

  return {
    fetching,
    filters,
    changeFilter,
    jobsData: getFilteredData(),
  };
};

export const useCopiableData = (data) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    copy(data);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, [data]);

  return {
    copied,
    handleCopy,
  };
};
